import React, { FC } from 'react';
import { components } from './data';

export const SKLanding: FC = () => {
  return (
    <>
      {components.map(({ name, props }, index) => {
        const C = name;
        /* @ts-expect-error: key type is never*/
        return <C {...props} key={`component-${index}`} />;
      })}
    </>
  );
};
